import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Event, EventService } from '../../../../services/event.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-create-event-modal',
  templateUrl: './create-event-modal.component.html',
  styleUrls: ['./create-event-modal.component.scss']
})
export class CreateEventModalComponent implements OnInit {

  minDate: Date = new Date();
  maxDate: Date = new Date();
  maximumPastEventDays = environment.maximumPastEventDays;
  maximumFutureEventDays = environment.maximumFutureEventDays;

  @ViewChild('modal', { static: false }) private modalContent: TemplateRef<CreateEventModalComponent>
  private modalRef: NgbModalRef

  newEvent: Event = {
    eventId: undefined,
    eventName: null,
    eventDescription: null,
    eventJustification: null,
    eventStartDate: null,
    eventEndDate: null,
    eventRequestPackageIds: []
  }

  saveButtonClicked: boolean = false;


  constructor(
    private modalService: NgbModal,
    private eventsService: EventService
  ) {
  }

  ngOnInit() {
  }

  open(): Promise<any> {
    let rightNow = new Date();
    this.minDate = new Date(rightNow.getFullYear(), rightNow.getMonth(), rightNow.getDate() - this.maximumPastEventDays, 0, 0, 0, 0);
    this.maxDate = new Date(rightNow.getFullYear(), rightNow.getMonth(), rightNow.getDate() + this.maximumFutureEventDays, 23, 59, 59, 999);
    this.modalRef = this.modalService.open(this.modalContent, { ariaLabelledBy: 'modal-basic-title', size: 'xl' });
    return this.modalRef.result;
  }

  async close() {
    console.log('CreateEventModal closed');
    this.modalRef.close(true);
  }

  async dismiss() {
    console.log('CreateEventModal dismissed');
    this.modalRef.dismiss('X');
  }

  createEvent() {
    this.saveButtonClicked = true;

    this.eventsService.createEventObj(this.newEvent);

    this.saveButtonClicked = false;
    if (true) { // TODO capture success/failure from eventsService?
      this.close();
    }
  }

  clearForm() {
    this.newEvent = {
      eventId: undefined,
      eventName: null,
      eventDescription: null,
      eventJustification: null,
      eventStartDate: null,
      eventEndDate: null,
      eventRequestPackageIds: []
    }
  }
}
